module.exports = __webpack_public_path__ + "img/gu.4d48accd.svg";